import React from "react";
import ReactTooltip from "react-tooltip";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
// import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import { Box, Button } from "@material-ui/core";
import { DOWNLOAD_CLAIMS_TOOLTIP, EXPORT_LIST } from "../../constants/index";
import { useStyles } from "./styles";

function ExportButton(props) {
  const {
    classes: { capitalize, borderRadius, marginLeft },
    handlePolicyExport,
    isExportClicked,
    count,
  } = props;

  return (
    <Box ml={2}>
      <Button
        variant="contained"
        color="secondary"
        size={"small"}
        className={`${borderRadius} ${marginLeft} ${capitalize}`}
        onClick={handlePolicyExport}
        disabled={!count || isExportClicked}
        data-tip={DOWNLOAD_CLAIMS_TOOLTIP}
      >
        {/* <SystemUpdateAltIcon style={{ margin: "3px 6px" }} /> */}
        <CloudDownloadIcon style={{ margin: "3px 6px" }} />
        {EXPORT_LIST}
      </Button>
      <ReactTooltip html={true} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ExportButton);
